import localeText from "../../../../../locale";
import StatusBadge from "../../../components/list/StatusBadge";

// Status da fatura eletrônica: emitida (WEB-n/ano), pendente ou com erro (mensagem no hover)
const InvoiceBadge = ({ status, number, year, errorMessage }) => {
  if (status === "SENT") {
    return <StatusBadge tone="good">{`WEB-${number}/${year}`}</StatusBadge>;
  }
  if (status === "PENDING") {
    return <StatusBadge tone="warning">{localeText("invoiceStatusPending")}</StatusBadge>;
  }
  if (status === "ERROR") {
    return (
      <span title={errorMessage || ""} className="admin-report__invoice-error">
        <StatusBadge tone="bad" icon="pi pi-exclamation-triangle">
          {localeText("invoiceStatusError")}
        </StatusBadge>
      </span>
    );
  }
  return <span className="admin-muted">—</span>;
};

export default InvoiceBadge;
